import { NgrxValueConverter } from 'ngrx-forms';

export const numberConverter: NgrxValueConverter<string | null, number | null> = {
  convertViewToStateValue(value: string | null) {
    if (value === null) {
      return null;
    }
    return +value;
  },
  convertStateToViewValue(value: number | null) {
    if (value === null) {
      return null;
    }

    return value.toString();
  },
};
